// extracted by mini-css-extract-plugin
export default {"readme":"Readme_readme__gZCbM","readmeCentered":"Readme_readmeCentered__tVWDM","message":"Readme_message__jKjIL"};